import React from "react";
import FTSReport from "../AdminPortal/FTSReport";

const DMFTSReport = () => {
  return <FTSReport />;
};

export default DMFTSReport;
